var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 94,
    viewBox: "0 0 75 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0747 80.9999C51.0747 80.9999 51.4099 68.3915 51.6334 65.1506C51.8569 61.9098 52.0804 61.9098 51.0747 60.1217C51.0747 60.1217 48.1691 54.4599 48.0198 49.0957V42.9117C48.0198 42.9117 47.8705 41.3472 48.3926 40.0062C48.9138 38.6651 48.3926 38.1046 48.9889 36.2986C49.5852 34.4927 51.0094 33.0774 51.8247 32.4811C52.6401 31.8848 55.1729 30.7673 55.7692 31.9599C56.3655 33.1517 57.1621 36.0286 58.0042 37.6218C58.2456 38.0786 59.01 39.9686 59.1593 40.5649C59.3086 41.1612 59.7869 42.3351 61.2826 42.2412",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8354 39.6129C58.8354 39.6129 60.5546 44.7 58.822 45.2587C57.0893 45.8175 55.6553 43.6942 55.0411 42.3531C54.4269 41.0121 54.5941 41.0675 54.2588 40.5097C53.9236 39.9518 53.5883 39.6156 53.1413 39.0569C52.6943 38.4981 51.7448 37.174 51.4087 36.2997",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.957 40.5649C49.957 40.5649 53.2292 40.5363 53.8845 39.9641",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.641 31.0658C54.641 31.0658 54.4837 26.4839 55.3777 25.4227C56.2717 24.3606 57.3338 24.4169 57.3338 24.4169",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4575 81C69.4575 81 69.5693 66.2682 69.4575 64.8155C69.3457 63.3627 69.1786 60.7923 69.1786 60.7923C69.1786 60.7923 69.0668 58.222 69.7937 57.2162C70.5205 56.2105 71.5817 52.4672 71.6935 48.7784C71.8052 45.0897 71.6935 42.7759 71.6935 42.7759C71.6935 42.7759 71.7489 40.7885 71.0784 39.7264C70.4078 38.6643 68.8701 37.3411 68.3963 36.5419C67.5416 35.0989 65.7696 32.2398 64.4286 30.5626C63.0876 28.8854 63.3665 29.6686 61.6348 27.0983C59.903 24.528 59.1762 23.6894 58.1704 23.8574C57.1646 24.0255 56.5504 25.5901 56.6613 27.4335C56.7722 29.277 56.9402 31.2886 59.3434 34.3068C61.7465 37.325 61.9137 37.0443 62.696 39.4475C63.4783 41.8506 64.931 43.5823 64.931 43.5823",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7427 46.8785C71.7427 46.8785 73.2571 44.8249 73.537 40.2636C73.8168 35.7023 73.4252 32.0153 73.258 30.3945C73.0908 28.7736 73.09 25.9395 73.09 23.8368C73.09 21.734 72.8459 17.6546 72.6885 15.3078C72.5312 12.961 72.4194 12.1787 72.0842 9.88818C71.7489 7.59769 71.1901 4.97104 69.0668 5.08279C66.9435 5.19455 67.5577 8.43539 67.5577 12.8501C67.5577 17.2648 67.6158 17.2648 67.4755 20.1704C67.3351 23.076 67.4755 27.3226 67.4755 27.3226",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9639 26.1211V21.3434C60.9639 21.3434 61.0193 19.1638 61.5226 16.1473C62.026 13.1309 62.1932 10.2244 62.1932 10.2244L62.4167 5.08017C62.4167 5.08017 62.2486 1.11606 64.7072 1.0043C67.1657 0.892552 67.3347 2.9649 67.4116 6.25671C67.4885 9.54851 67.5564 12.8501 67.5564 12.8501",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6965 39.6147C62.6965 39.6147 62.0447 39.3912 61.2812 43.526",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3843 27.49C66.3843 27.49 66.3843 27.751 66.3843 26.3724C66.3843 24.9938 67.4124 21.7342 67.4124 21.7342C67.4124 21.7342 67.5528 19.2202 67.5572 17.1523",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8984 52.5625V71.293C35.8984 74.4049 34.9219 76.8659 32.9688 78.6758C31.0286 80.4857 28.3724 81.3906 25 81.3906C21.6797 81.3906 19.043 80.5117 17.0898 78.7539C15.1367 76.9961 14.1406 74.5807 14.1016 71.5078V52.5625H19.9609V71.332C19.9609 73.194 20.4036 74.5547 21.2891 75.4141C22.1875 76.2604 23.4245 76.6836 25 76.6836C28.2943 76.6836 29.9674 74.9518 30.0195 71.4883V52.5625H35.8984Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 69.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUhand);
export default __webpack_public_path__ + "static/media/Uhand.5f96d29e8d8beec9c0f094201aedb43e.svg";
export { ForwardRef as ReactComponent };